export const SetValueProps = (formik: any, name: string) => ({
  value: formik.values[name],
  setValue: formik.setFieldValue,
  onBlur: formik.handleBlur,
  error: formik.touched[name] ? formik.errors[name] : undefined,
})
